import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "priceshow-other-modal" }
const _hoisted_2 = { class: "priceshow-other-modal__heading" }
const _hoisted_3 = { class: "row g-0" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "fs-h4" }
const _hoisted_6 = { class: "col-auto position-relative" }
const _hoisted_7 = { class: "fs-h3 m-0" }
const _hoisted_8 = { class: "row gx-0 gy-2" }
const _hoisted_9 = { class: "col-12 col-xxl-auto" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-xxl" }, null, -1)
const _hoisted_11 = { class: "col-12 col-xxl-auto" }
const _hoisted_12 = ["disabled"]

import {
  PropType,
  computed,
  reactive,
} from 'vue';
import { useRouter } from 'vue-router';
import ClickWrapper from '@/components/ClickWrapper.vue';
import Product from '@/classes/Product';
import BaseCalculatorUsageField from '@/components/BaseCalculator/BaseCalculatorUsageField.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons';


export default /*#__PURE__*/_defineComponent({
  props: {
  current: {
    type: Object as PropType<Product>,
    required: true,
  },
  priceshowParams: {
    type: Object,
    required: true,
  },
},
  emits: ['close', 'decline'],
  setup(__props) {

const props = __props

library.add(faTimes);




const router = useRouter();

const buttonDeclineLabel = computed(() => {
  switch (props.current.branch) {
    case 'power':
      return 'Ohne Ökogas fortfahren';
    case 'gas':
      return 'Ohne Ökostrom fortfahren';
    default:
      return 'Ohne weiteres Produkt fortfahren';
  }
});

const buttonAcceptLabel = computed(() => {
  switch (props.current.branch) {
    case 'power':
      return 'Ökogasprodukte anzeigen';
    case 'gas':
      return 'Ökostromprodukte anzeigen';
    default:
      return 'Produkte anzeigen';
  }
});

const currentBranchLabel = computed(() => {
  const branchLabel = props.current.branchTranslated;

  return branchLabel ? `${branchLabel}produkt` : 'Produkt';
});

const otherBranchLabel = computed(() => {
  switch (props.current.branch) {
    case 'power':
      return 'Ökogas';
    case 'gas':
      return 'Ökostrom';
    default:
      return 'Etwas Anderes';
  }
});

const otherBranch = computed(() => {
  switch (props.current.branch) {
    case 'power':
      return 'gas';
    case 'gas':
    default:
      return 'power';
  }
});

const options = reactive({
  usage: null,
  branch: otherBranch.value,
});

const usageValid = computed(() => parseInt(`${options.usage || ''}`, 10) > 0);

const translateBranch = ($branch: string) => {
  switch ($branch) {
    case 'power':
      return 'strom';
    case 'gas':
      return 'gas';
    default:
      return $branch;
  }
};

const onAccept = () => {
  let path = '/preisanzeige/';

  if (props.priceshowParams.business) {
    path += 'gewerbekunden/';
  } else {
    path += 'privatkunden/';
  }

  const params: Record<string, string> = {
    stadt: props.priceshowParams.city as string,
    strasse: props.priceshowParams.street as string,
    hausnummer: props.priceshowParams.houseNumber as string,
  };

  const urlParams = new URLSearchParams(params);

  path += `${translateBranch(otherBranch.value)}/${props.priceshowParams.postcode}/${options.usage}/?${urlParams.toString()}`;

  router.push(path);
};

return (_ctx: any,_cache: any) => {
  const _component_BaseSpacer = _resolveComponent("BaseSpacer")!
  const _component_IoCard = _resolveComponent("IoCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ClickWrapper, {
      class: "priceshow-other-modal__container",
      ref: (_value, _refs) => {
        _refs['root'] = _value
      }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_IoCard, {
          "text-align": "start",
          "link-style": "full"
        }, {
          prebody: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, " Ihr " + _toDisplayString(_unref(currentBranchLabel)) + " wurde in den Warenkorb gelegt. ", 1)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("button", {
                    class: "close fs-h4",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$.emit('decline')))
                  }, [
                    _createVNode(_unref(FontAwesomeIcon), { icon: "fa-light fa-times" })
                  ])
                ])
              ])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_7, " Möchten Sie auch " + _toDisplayString(_unref(otherBranchLabel)) + " dazubestellen? ", 1),
            _createVNode(_component_BaseSpacer, { size: "m" }),
            _createVNode(BaseCalculatorUsageField, {
              label: `Ihr ${_unref(otherBranchLabel)}verbrauch in kWh`,
              modelValue: _unref(options).usage,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(options).usage) = $event)),
              showValidCheck: _unref(usageValid),
              branch: _unref(options).branch
            }, null, 8, ["label", "modelValue", "showValidCheck", "branch"]),
            _createVNode(_component_BaseSpacer, { size: "m" }),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$.emit('decline'))),
                  class: "btn btn-outline-dark w-100"
                }, _toDisplayString(_unref(buttonDeclineLabel)), 1)
              ]),
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  onClick: onAccept,
                  disabled: !_unref(usageValid),
                  class: "btn btn-primary w-100"
                }, _toDisplayString(_unref(buttonAcceptLabel)), 9, _hoisted_12)
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512)
  ]))
}
}

})